export default __webpack_public_path__ + "static/media/pexels-cottonbro-5999363.892f7950.jpg";